import { authwsEnvironment } from '../authws-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { AuthHeaders } from '../../../models/auth-headers';
import { ignoreData } from '../../../utils/ignore-data';
import { fromFetch } from 'rxjs/fetch';

/**
 * Change an Authenticated User's password
 * @param existingPassword Existing Password
 * @param newPassword New Password
 * @param alias Account Alias (Optional)
 */
export function postPasswordChange(
  this: unknown,
  request: {
    existingPassword: string;
    newPassword: string;
    alias?: string;
  }
) {
  return fromFetch(
    new Request(authwsEnvironment.resolve(this).passwordChangeUrl, {
      method: 'POST',
      headers: {
        ...requiredHeaders,
        ...new AuthHeaders(),
      },
      body: JSON.stringify(request),
    })
  ).pipe(ignoreData());
}
